import {
  call, put, select, takeLatest, takeEvery,
} from 'redux-saga/effects';
import findResult, { isValidFilter, wildcardFilter } from '@/utils/resultsHelper';
import MembershipService from '@/users/membership/service';
import { shareAPISaga } from '@/users/membership/helper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import {
  showSearchMembers,
  showSearchMembersError,
  shareSearchError,
  shareSearchSuccess,
  updateCurrentSearchPermissions,
} from '../actions';
import { searchLists, searchPermissions } from '../../constants';
import actions from '../constants';
import { destroySearch, refreshSearches } from '../../actions';

export function* fetchSearchMembers(action) {
  const items = yield select(selectors.searches);
  const item = findResult(items, action.category, action.code);
  const members = action.assignable ? item.unassignedMembers : item.members;

  const filter = action.filter || members.filter;
  if (!isValidFilter(filter, members)) { return; }

  const { response, error } = yield call(
    callAdapter,
    MembershipService.entityMembers('search', item.code, wildcardFilter(filter), action.assignable),
  );

  if (error) {
    yield put(showSearchMembersError(action.category, action.code, error, action.assignable));
  } else {
    yield put(showSearchMembers(
      action.category,
      action.code,
      response.items,
      response.paging.total,
      action.assignable,
    ));
  }
}

export function* share() {
  yield shareAPISaga(
    'search',
    searchPermissions,
    searchLists,
    selectors.sharingSearch,
    selectors.searches,
    shareSearchError,
    shareSearchSuccess,
    refreshSearches,
    destroySearch,
    updateCurrentSearchPermissions,
  );
}

export default function* shareSearchApi() {
  yield takeEvery(actions.FETCH_SEARCH_MEMBERS, fetchSearchMembers);
  yield takeLatest(actions.SHARE_SEARCH, share);
}
